export const AudienceType = {
  RemarketingList: {
    value: 'RemarketingList',
    mtEnum: 'Remessaging',
    i18nKey: 'Custom_Combination_AudienceType_RemarketingList',
    descI18nKey: 'Custom_Combination_Remarketing_List_Desc',
  },
  Custom: {
    value: 'Custom',
    mtEnum: 'Custom',
    i18nKey: 'Custom_Combination_AudienceType_Custom',
    descI18nKey: 'Custom_Combination_Custom_Audience_Desc',
  },
  Product: {
    value: 'Product',
    mtEnum: 'Product',
    i18nKey: 'Custom_Combination_AudienceType_Product',
    descI18nKey: 'Custom_Combination_Product_Audience_Desc',
  },
  RemarketingSimilar: {
    value: 'RemarketingSimilar',
    mtEnum: 'RemarketingSimilar',
    i18nKey: 'Custom_Combination_AudienceType_RemarketingSimilar',
    descI18nKey: 'Custom_Combination_Similar_Audience_Desc',
  },
  CustomerList: {
    value: 'CustomerList',
    mtEnum: 'CustomerList',
    i18nKey: 'Custom_Combination_AudienceType_CustomerList',
    descI18nKey: 'Custom_Combination_Customer_List_Desc',
  },
  ImpressionBasedList: {
    value: 'ImpressionBasedRemarketing',
    mtEnum: 'ImpressionBasedRemarketing',
    i18nKey: 'Custom_Combination_AudienceType_ImpressionBasedRemarketing',
    descI18nKey: 'Custom_Combination_ImpressionBasedRemarketing_Desc',
  },
};

export const AudienceSetOperator = {
  And: {
    value: 'AND',
    i18nKey: 'Custom_Combination_Audience_Set_Operator_AND_Text',
  },
  Or: {
    value: 'OR',
    i18nKey: 'Custom_Combination_Audience_Set_Operator_OR_Text',
  },
  Not: {
    value: 'NOT',
    i18nKey: 'Custom_Combination_Audience_Set_Operator_NOT_Text',
  },
};

export const MaxAudienceSets = 100;
export const MaxAudiencesInAudienceSet = 100;

export const NewAudienceDataNotLoadedError = i18n => new Error(i18n.getString('Error_AudienceDataNotLoaded'));

export const NewMaxAudienceSetsExceedingError = i18n => new Error(i18n.getString('Error_MaxAudienceSetsExceeding'));
export const NewMaxAudiencesExceedingError = i18n => new Error(i18n.getString('Error_MaxAudiencesExceeding'));
export const NewSimilarAudienceOperatorError = i18n => new Error(i18n.getString('Error_SimilarAudienceOperator'));
export const NewSimilarAudienceSetError = i18n => new Error(i18n.getString('Error_SimilarAudienceSet'));
export const NewCustomerListCombinationError = i18n => new Error(i18n.getString('Error_CustomerListCombination'));
export const NewCustomerAudiencesCombinationError = i18n => new Error(i18n.getString('Error_CustomerAudiencesCombination'));
export const NewEmptyAudienceSetError = i18n => new Error(i18n.getString('Error_EmptyAudienceSet'));
export const NewOnlyNotAudienceSetError = i18n => new Error(i18n.getString('Error_OnlyNotAudienceSet'));
export const NewNoAudienceSetError = i18n => new Error(i18n.getString('Error_NoAudienceSet'));
export const NewCombinedListEditNotByCreatorError = i18n => new Error(i18n.getString('Error_Internal'));
export const NewAudienceIdInvalidError = i18n => new Error(i18n.getString('Error_AudienceIdInvalid'));
export const NewInternalError = i18n => new Error(i18n.getString('Error_Internal'));
export const NewEnhancedCustomerListError = newI18n => new Error(newI18n.getString(_TL_('Similar Audience List cannot be combined with customer match lists or custom audiences.')));

export const NewAudienceInConfictSetError = (i18n, conflictAudiences) => {
  const errorMessage = conflictAudiences.length <= 1 ?
    i18n.getString('Error_ConflictSingle').replace('{{audience_name}}', conflictAudiences[0].Name) :
    i18n.getString('Error_ConflictMultiple').replace('{{audience_name}}', conflictAudiences[0].Name)
      .replace('{{rest_count}}', conflictAudiences.length - 1);
  return new Error(errorMessage);
};
